var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("dl", { staticClass: "--input-group" }, [
    _c("dt", [_vm._v(_vm._s(_vm.label))]),
    _vm._v(" "),
    _c("dd", { class: { "--fit": _vm.fit } }, [_vm._t("default")], 2)
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }